var module = angular.module('octopusApp.infrastructure');

module.directive("boundField", function () {
  return {
    restrict: 'E',
    transclude: true,
    replace: true,
    templateUrl: 'infrastructure/directives/views/bound-field.html',
    require:  '?^form',
    scope: {
      projectId: '=',
      projectEnvironmentsFilter: '=',
      localNames: '=',
      model: '=',
      resetValue: '=',
      parameter: '=',
      label: '@',
      bound: '=',
      isLocked: '='
    },
    link: function ($scope, element, attrs, $form) {
      $scope.boundText = boundText;
      $scope.bind = bind;
      $scope.unbind = unbind;
      $scope.bound = $scope.bound || {};
      $scope.isLocked = $scope.isLocked || function(){ return false; };

      var parameterUnboundValueRanges = {
        "Checkbox": function(param, value) {
          //console.log("eval checkbox", param, value);
          if (!value) {
            return false;
          }
          var lower = value.toLowerCase();
          return lower === "true" || lower === "false";
        },
        "Select": function (param, value) {
         // console.log("eval select", param, value);
          var options = param["Octopus.SelectOptions"].split("\n");
          return options.map(function(option) { return option.split('|')[0]; }).indexOf(value) >= 0;
        },
        "Sensitive": function (param, value) {
         // console.log("eval select", param, value);
          return typeof value === 'undefined' || typeof value === 'object';
        }
      };

      var refreshTextBoxness = function () {
        if($('.select2', element).length !== 0) {
          $scope.needsSpecialTextBox = true;
        } else {
          var x = $(".transcluded.input-boxes input[type='text'], .transcluded.input-boxes textarea", element);
          $scope.needsSpecialTextBox = x.length === 0;
        }
      };

      var refreshIsBound = function(){
        if ($scope.isLocked()) {
          bind();
          return;
        }

        if ($scope.model && typeof($scope.model) === 'string') {
          if ($scope.model.indexOf("#{") >= 0) {
            bind();
          }

          if ($scope.parameter) {
            var displaySettings = $scope.parameter.DisplaySettings;
            var controlType = displaySettings["Octopus.ControlType"];
            var isInRange = parameterUnboundValueRanges[controlType];
            if (isInRange) {
              if (!isInRange(displaySettings, $scope.model)) {
                bind();
              }
            }
          }
        }
      };

      function init() {
        refreshTextBoxness();
        refreshIsBound();

        $scope.$watch("model", function(newVal, oldVal) {
          if (newVal !== oldVal && $form) {
            $form.$setDirty();
          }

          refreshIsBound();
        });

        $scope.$watch($scope.isLocked, 
          function (newVal, oldVal) {
            if (newVal !== oldVal) {
              refreshIsBound();
            }
        });
      }

      function boundText() {
        if ($scope.isBound) {
          return "This field is bound";
        }
        return "This field supports custom bindings";
      }

      function bind() {
        if (typeof($scope.model) !== 'string') {
         $scope.model = '';
        }
        $scope.isBound = true;
        $scope.bound.isBound = true;
      }

      function unbind() {
        $scope.isBound = false;
        $scope.bound.isBound = false;

        if (typeof($scope.resetValue) === 'function') {
         $scope.model = $scope.resetValue();
        } else {
          $scope.model = $scope.resetValue;
        }
      }

      init();
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/bound_field.js
// module id = 653
// module chunks = 1